import {
  caretDownDesktop,
  caretUpDesktop,
} from "components/sections/headerV2/TopNav/Menu/Links/icons"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"

import "./DropdownMultiSelect.scss"

const DropdownMultiSelect = ({
  options,
  placeholder,
  selectedOptions,
  setSelectedOptions,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef()

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const toggleOption = option => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter(item => item !== option))
    } else {
      setSelectedOptions([...selectedOptions, option])
    }
  }

  const clearAll = () => {
    setSelectedOptions([])
    setIsOpen(false)
  }

  return (
    <div className="dropdown-multi-select" ref={dropdownRef}>
      <button
        className="dropdown-trigger"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        {selectedOptions.length > 0
          ? `${selectedOptions.length} Selected`
          : placeholder}
        <span className="caret-icon">
          {isOpen ? caretUpDesktop : caretDownDesktop}
        </span>
      </button>

      {isOpen && (
        <div className="dropdown-panel">
          {options.map(option => (
            <label className="dropdown-option" key={option}>
              <input
                checked={selectedOptions.includes(option)}
                onChange={() => toggleOption(option)}
                type="checkbox"
              />
              {option}
            </label>
          ))}
          <div className="dropdown-actions">
            <button className="clear-btn" onClick={clearAll} type="button">
              Clear All
            </button>
            <button
              className="apply-btn"
              onClick={() => setIsOpen(false)}
              type="button"
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

DropdownMultiSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  placeholder: PropTypes.string.isRequired,
  selectedOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedOptions: PropTypes.func.isRequired,
}

export default DropdownMultiSelect
